import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { RoleType } from "common";
import { MAX_NAVBAR_WIDTH } from "../config";
import { AppPage } from "../utils/AppPage";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { useIsInRole } from "../utils/useIsInRole";
import { AdminPanel } from "./AdminPanel";
import { DatabasePanel } from "./DatabasePanel";
import { LeadersPanel } from "./LeadersPanel";
import { TeamsPanel } from "./TeamsPanel";
import { YouthKidsPanel } from "./YouthKidsPanel";

export const PeoplePage = () => {
  const isDeveloper = useIsInRole(RoleType.Developer);
  const isAdmin = useIsInRole(RoleType.Admin);
  return (
    <AppPage title="People">
      <Tabs
        variant={"soft-rounded"}
        width={"100%"}
        maxWidth={MAX_NAVBAR_WIDTH}
        colorScheme={THEME_COLOR_SCHEME}
      >
        <TabList width={"100%"} overflowX={"auto"}>
          <Tab>Members</Tab>
          <Tab>Leaders</Tab>
          <Tab>Teams</Tab>
          {isDeveloper ? <Tab>Dev</Tab> : null}
          {isAdmin ? <Tab>Admin</Tab> : null}
        </TabList>
        <TabPanels>
          <TabPanel>
            <YouthKidsPanel />
          </TabPanel>
          <TabPanel>
            <LeadersPanel />
          </TabPanel>
          <TabPanel>
            <TeamsPanel />
          </TabPanel>
          {isDeveloper ? (
            <TabPanel>
              <DatabasePanel />
            </TabPanel>
          ) : null}
          {isAdmin ? (
            <TabPanel>
              <AdminPanel />
            </TabPanel>
          ) : null}
        </TabPanels>
      </Tabs>
    </AppPage>
  );
};
